module.exports = __webpack_public_path__ + "img/crisis-in-news.ff4ea05c.png";